import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { TabsHeader } from './TabsHeader';
import '../../styles/components/tabs.scss';

export interface ILinks {
  title: string;
  route: string;
}

interface TabsProps {
  links: ILinks[];
}

export const Tabs: FC<TabsProps> = ({ links }) => {
  return (
    <>
      {isMobile ? (
        <div className="scroll-wrapper">
          <TabsHeader links={links} />
        </div>
      ) : <TabsHeader links={links} />}
      <Outlet />
    </>
  );
};
